import React from "react";
import { useSpring, animated } from "@react-spring/web";
import Banner3 from "../../../images/newbannerblur.png";
import "@fontsource/manrope";
import "@fontsource/syne";
import { FaCheck } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./TextonImage.css";

function TextonImage() {
  const fadeIn = useSpring({
    opacity: 1,
    from: { opacity: 0 },
    config: { duration: 800 },
  });

  const slideUp = useSpring({
    opacity: 1,
    transform: "translateY(0px)",
    from: { opacity: 0, transform: "translateY(32px)" },
    delay: 200,
    config: { tension: 80, friction: 20 },
  });

  const subheadProps = useSpring({
    opacity: 1,
    transform: "translateY(0px)",
    from: { opacity: 0, transform: "translateY(24px)" },
    delay: 500,
    config: { tension: 80, friction: 20 },
  });

  const listItem1 = useSpring({
    opacity: 1,
    transform: "translateX(0px)",
    from: { opacity: 0, transform: "translateX(-20px)" },
    delay: 800,
    config: { tension: 90, friction: 22 },
  });

  const listItem2 = useSpring({
    opacity: 1,
    transform: "translateX(0px)",
    from: { opacity: 0, transform: "translateX(-20px)" },
    delay: 1000,
    config: { tension: 90, friction: 22 },
  });

  const listItem3 = useSpring({
    opacity: 1,
    transform: "translateX(0px)",
    from: { opacity: 0, transform: "translateX(-20px)" },
    delay: 1200,
    config: { tension: 90, friction: 22 },
  });

  const btnProps = useSpring({
    opacity: 1,
    transform: "translateY(0px)",
    from: { opacity: 0, transform: "translateY(16px)" },
    delay: 1500,
    config: { tension: 90, friction: 22 },
  });

  return (
    <animated.div className="hero-section" style={{ ...fadeIn, backgroundImage: `url(${Banner3})` }}>
      <div className="hero-inner">
        <div className="hero-content">
          <animated.h1 style={slideUp} className="hero-headline">
            Construction Management Made Easy
          </animated.h1>

          <animated.p style={subheadProps} className="hero-subhead">
            Empower Your Team and Take Control with Our Cutting Edge
            Construction Management Application!
          </animated.p>

          <div className="hero-features">
            <animated.div style={listItem1} className="feature-item">
              <span className="feature-icon"><FaCheck /></span>
              <span>Data-Driven Decision Making</span>
            </animated.div>
            <animated.div style={listItem2} className="feature-item">
              <span className="feature-icon"><FaCheck /></span>
              <span>Enhanced Communication and Collaboration</span>
            </animated.div>
            <animated.div style={listItem3} className="feature-item">
              <span className="feature-icon"><FaCheck /></span>
              <span>Early and Effective cost and Risk Management</span>
            </animated.div>
          </div>

          {/* <Link to="/RequestDemo">
            <animated.button style={btnProps} type="button" className="hero-cta">
              <b>Request Demo</b>
            </animated.button>
          </Link> */}

        </div>
      </div>
    </animated.div>
  );
}

export default TextonImage;